// Text carried over unchanged from the v1 site (FayshaaWeb frontend/src/pages/TermsOfService.jsx).
export const LAST_UPDATED = 'April 30, 2026';

export default function TermsBody() {
  return (
    <>
      <div>
        <p>
          Welcome to Faysha - Property by Result. These Terms of Service ("Terms") govern your access to and use of our website, services, and apartment rental facilities located in Cameroon. By accessing or using our services, you agree to be bound by these Terms.
        </p>
        <p>
          Please read these Terms carefully before using our services. If you do not agree with any part of these Terms, you may not access our services.
        </p>
      </div>

      <div>
        <h2>
          1. Definitions
        </h2>
        <ul>
          <li><strong>"We," "Us," "Our"</strong> refers to Faysha - Property by Result</li>
          <li><strong>"You," "Guest," "User"</strong> refers to the individual or entity using our services</li>
          <li><strong>"Services"</strong> refers to apartment rentals, website access, and related amenities</li>
          <li><strong>"Property"</strong> refers to our apartment units and facilities</li>
          <li><strong>"Booking"</strong> refers to a reservation for accommodation</li>
        </ul>
      </div>

      <div>
        <h2>
          2. Eligibility
        </h2>
        <p>
          To use our services, you must:
        </p>
        <ul>
          <li>Be at least 18 years of age</li>
          <li>Have the legal capacity to enter into binding contracts</li>
          <li>Provide accurate and complete information during registration and booking</li>
          <li>Comply with all applicable laws and regulations</li>
        </ul>
      </div>

      <div>
        <h2>
          3. Booking and Reservations
        </h2>

        <h3>
          3.1 Making a Booking
        </h3>
        <ul>
          <li>All bookings are subject to availability</li>
          <li>You must provide accurate personal and payment information</li>
          <li>A booking confirmation will be sent to your email upon successful reservation</li>
          <li>You will receive digital access codes via email prior to check-in</li>
        </ul>

        <h3>
          3.2 Payment
        </h3>
        <ul>
          <li>Payment is required at the time of booking</li>
          <li>We accept payments through Stripe (credit/debit cards)</li>
          <li>All prices are listed in XAF (Central African CFA Franc)</li>
          <li>Prices may vary based on dates, occupancy, and special events</li>
          <li>Additional charges may apply for extra guests or services</li>
        </ul>

        <h3>
          3.3 Confirmation and Changes
        </h3>
        <ul>
          <li>Booking confirmations are sent via email</li>
          <li>Changes to bookings are subject to availability and may incur fees</li>
          <li>We reserve the right to cancel bookings in case of force majeure or property issues</li>
        </ul>
      </div>

      <div>
        <h2>
          4. Cancellation and Refund Policy
        </h2>

        <h3>
          4.1 Guest Cancellations
        </h3>
        <ul>
          <li><strong>More than 14 days before check-in:</strong> Full refund minus processing fees</li>
          <li><strong>7-14 days before check-in:</strong> 50% refund</li>
          <li><strong>Less than 7 days before check-in:</strong> No refund</li>
          <li><strong>No-show:</strong> No refund</li>
        </ul>

        <h3>
          4.2 Our Cancellations
        </h3>
        <p>
          If we cancel your booking due to circumstances within our control, you will receive:
        </p>
        <ul>
          <li>Full refund of all payments made</li>
          <li>Assistance in finding alternative accommodation (if available)</li>
        </ul>
      </div>

      <div>
        <h2>
          5. Check-In and Check-Out
        </h2>
        <ul>
          <li><strong>Check-in time:</strong> 2:00 PM (14:00)</li>
          <li><strong>Check-out time:</strong> 11:00 AM</li>
          <li>Early check-in or late check-out may be available upon request and may incur additional charges</li>
          <li>You must present valid government-issued identification at check-in</li>
          <li>Digital access codes will be provided via email and SMS</li>
          <li>Late check-out without prior approval may result in additional charges</li>
        </ul>
      </div>

      <div>
        <h2>
          6. Guest Conduct and Responsibilities
        </h2>

        <h3>
          6.1 General Conduct
        </h3>
        <p>
          Guests agree to:
        </p>
        <ul>
          <li>Treat the property with respect and care</li>
          <li>Comply with all property rules and regulations</li>
          <li>Not exceed the maximum occupancy limit</li>
          <li>Not disturb other guests or neighbors</li>
          <li>Not engage in illegal activities on the premises</li>
          <li>Not smoke in non-designated areas</li>
          <li>Not bring pets without prior written approval</li>
        </ul>

        <h3>
          6.2 Damages and Losses
        </h3>
        <ul>
          <li>You are responsible for any damage to the property caused by you or your guests</li>
          <li>Report any damages or issues immediately to our staff</li>
          <li>We may charge your payment method for repair or replacement costs</li>
          <li>Lost key cards or access devices may incur replacement fees</li>
        </ul>
      </div>

      <div>
        <h2>
          7. Property Access and Amenities
        </h2>
        <ul>
          <li>Access to amenities (pool, gym, etc.) is included with your stay</li>
          <li>Amenities may have specific operating hours</li>
          <li>We reserve the right to close amenities for maintenance or safety reasons</li>
          <li>Use of amenities is at your own risk</li>
          <li>Children must be supervised by adults at all times in common areas</li>
        </ul>
      </div>

      <div>
        <h2>
          8. Internet and Technology Services
        </h2>
        <ul>
          <li>WiFi and Smart TV services are provided as amenities</li>
          <li>We do not guarantee uninterrupted internet service</li>
          <li>Use of our network must comply with applicable laws</li>
          <li>Illegal downloading or streaming is prohibited</li>
          <li>We are not liable for any security breaches on our network</li>
        </ul>
      </div>

      <div>
        <h2>
          9. Safety and Security
        </h2>
        <ul>
          <li>We employ smart access systems for your security</li>
          <li>Do not share access codes with unauthorized persons</li>
          <li>Report any security concerns immediately</li>
          <li>We are not responsible for personal belongings left in the apartment</li>
          <li>In case of emergency, contact local emergency services and our staff</li>
        </ul>
      </div>

      <div>
        <h2>
          10. Privacy and Data Protection
        </h2>
        <p>
          Your use of our services is also governed by our Privacy Policy. Please review our <a href="/privacy">Privacy Policy</a> to understand how we collect, use, and protect your personal information.
        </p>
      </div>

      <div>
        <h2>
          11. Limitation of Liability
        </h2>
        <p>
          To the fullest extent permitted by law:
        </p>
        <ul>
          <li>We are not liable for any indirect, incidental, special, or consequential damages</li>
          <li>Our total liability shall not exceed the amount paid for your booking</li>
          <li>We are not responsible for delays or failures due to circumstances beyond our control</li>
          <li>We are not liable for personal injury or property damage except where caused by our negligence</li>
        </ul>
      </div>

      <div>
        <h2>
          12. Force Majeure
        </h2>
        <p>
          We are not liable for any failure to perform our obligations due to circumstances beyond our reasonable control, including but not limited to: natural disasters, war, terrorism, riots, civil unrest, government actions, pandemics, or utility failures.
        </p>
      </div>

      <div>
        <h2>
          13. Intellectual Property
        </h2>
        <p>
          All content on our website, including text, graphics, logos, images, and software, is our property or our licensors' property and is protected by copyright and trademark laws. You may not:
        </p>
        <ul>
          <li>Reproduce, distribute, or modify our content without permission</li>
          <li>Use our trademarks or branding without authorization</li>
          <li>Create derivative works based on our content</li>
        </ul>
      </div>

      <div>
        <h2>
          14. Governing Law and Dispute Resolution
        </h2>
        <p>
          These Terms are governed by the laws of Cameroon. Any disputes arising from these Terms or your use of our services shall be resolved through:
        </p>
        <ol>
          <li>Good faith negotiation between the parties</li>
          <li>If unresolved, mediation in Cameroon</li>
          <li>If mediation fails, litigation in the courts of Cameroon</li>
        </ol>
      </div>

      <div>
        <h2>
          15. Modifications to Terms
        </h2>
        <p>
          We reserve the right to modify these Terms at any time. We will notify you of material changes by posting the updated Terms on our website and updating the "Last updated" date. Your continued use of our services after such changes constitutes acceptance of the modified Terms.
        </p>
      </div>

      <div>
        <h2>
          16. Severability
        </h2>
        <p>
          If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall continue in full force and effect.
        </p>
      </div>

      <div>
        <h2>
          17. Entire Agreement
        </h2>
        <p>
          These Terms, together with our Privacy Policy and any other policies referenced herein, constitute the entire agreement between you and us regarding the use of our services.
        </p>
      </div>

      <div>
        <h2>
          18. Contact Information
        </h2>
        <p>
          If you have any questions about these Terms of Service, please contact us:
        </p>
        <div>
          <p><strong>Faysha - Property by Result</strong></p>
          <p>Email: <a href="mailto:info@fayshaa.com">info@fayshaa.com</a></p>
          <p>Website: <a href="https://www.fayshaa.com">www.fayshaa.com</a></p>
          <p>Location: Cameroon</p>
        </div>
      </div>

      <div>
        <p>
          By using our website and services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
        </p>
      </div>
    </>
  );
}
